module.exports = __webpack_public_path__ + "static/media/covid_waiting.5c1d9c87.jpg";